<template>
  <div v-if="resources.length > 0" class="ui basic segment">
    <h3 class="ui header">Resources</h3>
    <div class="ui vertically fitted basic segment">
      <div class="ui items">
        <div class="item" v-for="resource in resources" :key="resource.title">
          <div class="content">
            <div class="ui text">{{ resource.title }}</div>
            <a :href="resource.url" target="_blank">{{ resource.url }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resources',
  props: ['syncguid'],
  computed: {
    resources() {
      return this.$store.getters.contentById(this.syncguid).resources || [];
    },
  },
};
</script>
